import React from 'react';

import { Switch, Route } from 'react-router-dom';

import DashboardLayout from 'components/Layouts/Admin/Dashboard';
import PendingContent from 'components/Pages/Admin/PendingContent';
import { MediaLibrary } from 'components/Pages/FileLibrary';
import CustomRedirect from 'components/shared/CustomRedirect';
import ErrorScreen from 'components/shared/ErrorScreen';
import * as routes from 'constants/routes';
import { useAccountPath } from 'hooks/useAccountPath';

import SuperAdminRoute from '../SuperAdminRoute';

function DashboardRoutes() {
  const getPath = useAccountPath();

  return (
    <DashboardLayout>
      <Switch>
        <SuperAdminRoute path={routes.PENDING_CONTENT_PATH} component={PendingContent} />
        <Route path={routes.CONTENT_LIBRARY_PATH}>
          <CustomRedirect to={getPath(routes.CONTENT_LIBRARY_PATH)} />
        </Route>
        <Route path={routes.MEDIA_LIBRARY_PATH} component={MediaLibrary} />
        <Route path={routes.ITINERARIES_PATH}>
          <CustomRedirect to={getPath(routes.ITINERARIES_PATH)} />
        </Route>
        <Route render={() => <ErrorScreen status="404" />} />
      </Switch>
    </DashboardLayout>
  );
}

export default DashboardRoutes;
